import { Component } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { Observable } from 'rxjs/Rx';
import * as $ from 'jquery';

@Component({
    selector: 'app-home-banner',
    templateUrl: './_banner.component.html',
    styleUrls: ['./_banner.component.css'],
    animations: [
        trigger('enterAnimation', [
            transition(':enter', [
                style({ 'opacity': 0 }),
                animate('500ms', style({ 'opacity': 1 }))
            ]),
            transition(':leave', [
                style({ 'opacity': 1 }),
                animate('500ms', style({ 'opacity': 0 }))
            ])
        ])
    ]
})

export class Home_BannerComponent {
    // Banner fixo - não precisa mais de view ou timer
}
